module.exports = __webpack_public_path__ + "img/nonet.f69149e0.png";